"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Check = void 0;
const react_1 = __importDefault(require("react"));
const Check = () => (react_1.default.createElement("svg", { width: "16", height: "12", viewBox: "0 0 16 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M2 6.95L5.72414 11L14 2", stroke: "#21145A", strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" })));
exports.Check = Check;
